/**
 * Режим обрезки: один источник правды для App (id заказа) и Home (черновик).
 * Без нормализации /cropping/ не совпадал с /cropping — uniqId уходил в crop-ключи,
 * а isCroppingMode в Home был false, черновик читался/писался под другими ключами.
 */
export function isCroppingPathname() {
	try {
		const raw = String(window.location.pathname || "");
		const p = raw.replace(/\/+$/, "") || "/";
		return p === "/cropping";
	} catch (e) {
		return false;
	}
}
